export default __webpack_public_path__ + "static/combining-376c5c36188180303a9b15444ac3f320.png";